import script from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=49411f4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49411f4f"]])

export default __exports__